require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-6-inviting-people.json") })
        }
      }, "path---article-6-inviting-people");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-6-inviting-people!./.cache/json/article-6-inviting-people.json
// module id = 559
// module chunks = 231608221292675